/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import FilterBarV2 from "components/cashCenter/filter-bar";
import Loader from "components/PageLoader";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { useGetCashCenterListPaginated } from "../../services/cash-center";
import { initialDataState } from "./constants";

export default function CashCenterList() {
  const [cashCenters, setCashCenters] = useState([]);

  const [dataState, setDataState] = useState(initialDataState);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const user = useUser();
  const pageSize = 25;
  const [filters, setFilters] = useState({
    searchCriteria: "",
  });
  const {
    mutate: getCashCenterList,
    isSuccess: cashCenterListAvailable,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    // error: cashCenterListError,
    reset: resetCashCenterList,
  } = useGetCashCenterListPaginated();

  useEffect(() => {
    if (cashCenterListAvailable) {
      setCashCenters(cashCenterList.data.data);
      setTotalRecords(cashCenterList.data.totalRecords);
      resetCashCenterList();
    }
  }, [cashCenterListAvailable]);

  useEffect(() => {
    setCurrentPage(1);
    getCashCenterList({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
    });
  }, [filters]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getCashCenterList({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
    });
  };
  const viewCell = ({ dataItem }) => {
    return (
      <td>
        {canViewDetails ? (
          <Flex
            as={Link}
            to={`${Paths.cashCenterDetails}/${dataItem.cashCenterId}`}
            style={{ cursor: "pointer", color: "blue" }}
            title="View Details"
          >
            {dataItem.name}
          </Flex>
        ) : (
          <Flex>{dataItem.name}</Flex>
        )}
      </td>
    );
  };
  const editCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          as={Link}
          to={`${Paths.editCashCenter}/${dataItem.cashCenterId}`}
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Edit Cash Center"
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  // const deleteCell = ({ dataItem }) => {
  //   const onDelete = () => {
  //     deleteCashCenter(dataItem.cashCenterId);
  //     setReload(!reload);
  //   };

  //   return (
  //     <td>
  //       <Flex
  //         justifyContent="center"
  //         w="100%"
  //         title="Delete Cash Center"
  //         cursor="pointer"
  //         onClick={() => {
  //           sweetAlert({
  //             title: "Warning!",
  //             text: `Cash Center ${dataItem.name} will be permanently deleted!`,
  //             icon: "warning",
  //             confirmButtonText: "Delete",
  //             confirmButtonColor: "red",
  //             iconColor: "red",
  //             reverseButtons: true,
  //             onConfirm: onDelete,
  //             showCancelButton: true,
  //           });
  //         }}
  //       >
  //         <MdDeleteSweep fontSize="18px" color="red" />
  //       </Flex>
  //     </td>
  //   );
  // };

  const canEdit = useMemo(() => {
    return HasPermission(user, "CashCenter", "Edit");
  }, [user]);

  const canViewDetails = useMemo(() => {
    return HasPermission(user, "Customer", "View");
  }, [user]);

  // const canDelete = useMemo(() => {
  //   return HasPermission(user, "Customer", "Delete");
  // }, [user]);

  const loadingBayCell = ({ dataItem }) => {
    return (
      <td>
        {dataItem.loadingBayArea}({dataItem.loadingBayCapacity})
      </td>
    );
  };

  return (
    <Flex className="main-container">
      {gettingCashCenterList ? <Loader /> : <></>}
      <Card m="20px">
        <CardBody>
          <FilterBarV2
            getList={(filter) => {
              setFilters({
                searchCriteria: filter,
              });
            }}
          />
          <Grid
            data={process(cashCenters || [], { ...dataState, skip: 0 })}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            className="customer-list-grid"
          >
            <Column field="locationId" title="Id" width={120} />
            <Column field="name" title="Name" cell={viewCell} />
            <Column field="country" title="Country" width={120} />
            <Column field="city" title="City" width={120} />
            <Column field="state" title="State" width={120} />
            <Column
              field="loadingBayArea"
              title="Loading Bay Area(Capacity)"
              cell={loadingBayCell}
            />

            <Column field="type" title="Type" />

            {canEdit ? (
              <Column
                field="status"
                title="Edit"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={editCell}
                sortable={false}
                filterable={false}
              />
            ) : (
              <></>
            )}
            {/* {canDelete ? (
              <Column
                field="status"
                title="Delete"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={deleteCell}
              />
            ) : (
              <></>
            )} */}
            {/* <Column width="100" title="Actions" className="text-center" filterable={false} cell={EditButtonCell} /> */}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
